<nav class="sidebar d-flex flex-column justify-content-between vh-100" role="navigation">
  <div>
    <div class="p-3 d-flex align-items-center">
      <img    ngSrc="assets/images/logo.svg"
        alt="Logo Fulmine"
        class="logo-img me-2"
        width="130"
        height="69"
        priority/>
      </div>
      <app-info-user></app-info-user>

      <ul class="nav flex-column">
        @for (item of sidebarItems(); track item) {
          <li class="nav-item" *kaHasRoles="item.roles;checkRealm:true">
            <a class="nav-link d-flex align-items-center"
              [routerLink]="item.route"
              [routerLinkActive]="'active'">
              <div class="flex-fill">
                @if (item.icon) {
                  <i [class]="item.icon + ' me-3'"></i>
                  } {{ item.label }}
                </div>
                @if(item.badge){
                  <span class="badge">{{item.badgeValue}}</span> }
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="py-3">
          <ul class="nav flex-column">
            @for (item of sidebarSecondaryItems(); track item) {
              <li class="nav-item" *kaHasRoles="item.roles;checkRealm:true">
                <a class="nav-link" (click)="item.isCollapsed=!item.isCollapsed">
                  @if (item.icon) {
                    <i [class]="item.icon + ' me-3'"></i>
                    } {{ item.label }}
                  </a>


                  <div [ngbCollapse]="getCollapse(item)" class="px-2">
                    @for (iteml2 of item.items; track iteml2) {
                      <li class="nav-item" *kaHasRoles="iteml2.roles;checkRealm:true">
                        <a class="nav-link d-flex" [routerLink]="iteml2.route" [routerLinkActive]="'active'">
                          @if (iteml2.icon) {
                            <i [class]="iteml2.icon + ' me-3'"></i>
                          }
                          <div>
                            {{ iteml2.label }}
                          </div>

                        </a>
                      </li>
                    }
                  </div>


                </li>
              }

            </ul>
            <ul class="nav flex-column">
              <li class="nav-item">
                <button class="nav-link text-start btn-menu" (click)="logout()">
                  <i class="bi bi-box-arrow-right me-3"></i>Logout
                </button>
              </li>
            </ul>



          </div>
        </nav>